import React from 'react';
import WarehouseOpsPage from './WarehouseOpsPage';
export default function DispatchManifest() {
  return <WarehouseOpsPage mode="dispatch" title="Dispatch Manifest" subtitle="Record driver, vehicle, and assigned shipments" />;
}
